(function () {
  'use strict';

  var SUPPORTED_QUANTITIES = [5, 25, 50, 100, 250, 500];
  var UNIT_PRICES_CENTS = {
    single: { 5: 160, 25: 144, 50: 124, 100: 84, 250: 55, 500: 43 },
    double: { 5: 232, 25: 209, 50: 180, 100: 122, 250: 80, 500: 62 }
  };
  var MIN_QTY = 5;
  var MAX_QTY = 500;

  var _state = null;
  var _helpers = null;

  function isCoasterProduct(ctx) {
    ctx = ctx || {};
    var prod = ctx.product || window.__ZUG_PRODUCT__ || {};
    var handle = (prod.handle || '').toLowerCase();
    var rawTags = prod.tags;
    var tags = [];
    if (Array.isArray(rawTags)) {
      tags = rawTags.map(function (t) { return ('' + t).toLowerCase().trim(); });
    } else if (typeof rawTags === 'string') {
      tags = rawTags.split(',').map(function (t) { return t.toLowerCase().trim(); });
    }
    var type = (prod.type || '').toLowerCase().trim();
    if (handle.indexOf('coaster') !== -1) return true;
    for (var i = 0; i < tags.length; i++) {
      if (tags[i] === 'coaster' || tags[i] === 'coasters') return true;
    }
    if (type === 'coasters') return true;
    return false;
  }

  function getPricing(qty, opts) {
    opts = opts || {};
    qty = Number(qty);
    if (!Number.isInteger(qty) || SUPPORTED_QUANTITIES.indexOf(qty) === -1) return null;
    var side = opts.doubleSided ? 'double' : 'single';
    var unitPriceCents = UNIT_PRICES_CENTS[side][qty];
    return {
      qty: qty,
      unitPrice: unitPriceCents / 100,
      total: (unitPriceCents * qty) / 100,
      tierLow: qty,
      tierHigh: qty
    };
  }

  function _ensureCoasterState(modalState) {
    if (!modalState.coaster) {
      modalState.coaster = {
        enabled: false,
        doubleSided: false,
        activeSide: 'front',
        uploads: {
          front: { upload_id: null, original_url: null, preview_url: null, approved: false, note: '' },
          back: { upload_id: null, original_url: null, preview_url: null, approved: false, note: '' }
        }
      };
    }
    return modalState.coaster;
  }

  function _syncUI() {
    if (!_state) return;
    var cs = _state.coaster;
    if (!cs) return;
    var dsArea = document.getElementById('zug-coaster-ds-area');
    var frontStatus = document.getElementById('zug-coaster-front-status');
    var backStatus = document.getElementById('zug-coaster-back-status');
    var sideToggle = document.getElementById('zug-coaster-side-toggle');
    var frontChip = document.getElementById('zug-coaster-chip-front');
    var backChip = document.getElementById('zug-coaster-chip-back');
    var printingHidden = document.getElementById('zug-printing-hidden');
    var printingValue = document.getElementById('zug-printing-value');
    var printingBtns = document.querySelectorAll('.zug-printing__opt');

    if (printingHidden) printingHidden.value = cs.doubleSided ? 'double' : 'single';
    if (printingValue) printingValue.textContent = cs.doubleSided ? 'Double sided' : 'Single sided';
    printingBtns.forEach(function(btn) {
      var isMatch = (btn.dataset.printing === 'double') === cs.doubleSided;
      btn.classList.toggle('is-active', isMatch);
      btn.setAttribute('aria-checked', isMatch ? 'true' : 'false');
    });
    if (dsArea) dsArea.style.display = cs.doubleSided ? 'block' : 'none';

    if (frontStatus) {
      frontStatus.textContent = cs.uploads.front.upload_id ? 'Front: Uploaded \u2713' : 'Front: Missing';
      frontStatus.classList.toggle('is-complete', !!cs.uploads.front.upload_id);
    }
    if (backStatus) {
      backStatus.textContent = cs.uploads.back.upload_id ? 'Back: Uploaded \u2713' : 'Back: Missing';
      backStatus.classList.toggle('is-complete', !!cs.uploads.back.upload_id);
    }

    if (sideToggle) sideToggle.style.display = cs.doubleSided ? 'flex' : 'none';
    if (frontChip) frontChip.classList.toggle('is-active', cs.activeSide === 'front');
    if (backChip) backChip.classList.toggle('is-active', cs.activeSide === 'back');
  }

  function _switchPreviewSide(side) {
    if (!_state || !_state.coaster) return;
    _state.coaster.activeSide = side;
    var cs = _state.coaster;
    var upload = cs.uploads[side];
    if (upload && upload.preview_url && _helpers && _helpers.setPreviewSrc) {
      _helpers.setPreviewSrc(upload.preview_url);
    }
    _syncUI();
    console.log('[ZUG][COASTER] switched preview side:', side);
  }

  function onToggleDoubleSided(on) {
    if (!_state) return;
    var cs = _ensureCoasterState(_state);
    cs.doubleSided = !!on;
    if (!on) {
      cs.activeSide = 'front';
      cs.uploads.back = { upload_id: null, original_url: null, preview_url: null, approved: false, note: '' };
    }
    _syncUI();
    console.log('[ZUG][COASTER] double-sided:', cs.doubleSided);
  }

  function onUploadComplete(side, data) {
    if (!_state) return;
    var cs = _ensureCoasterState(_state);
    if (side !== 'front' && side !== 'back') return;
    cs.uploads[side] = {
      upload_id: data.upload_id || null,
      original_url: data.original_url || null,
      preview_url: data.preview_url || null,
      approved: true,
      note: data.note || ''
    };
    _syncUI();
    console.log('[ZUG][COASTER] upload complete for side:', side, data);
  }

  function validate() {
    if (!_state || !_state.coaster) return { valid: true };
    var cs = _state.coaster;
    if (!cs.enabled) return { valid: true };
    if (cs.doubleSided) {
      if (!cs.uploads.front.upload_id) {
        return { valid: false, missingSide: 'front', message: 'Please upload your Front artwork to continue.' };
      }
      if (!cs.uploads.back.upload_id) {
        return { valid: false, missingSide: 'back', message: 'Please upload your Back artwork to continue.' };
      }
    }
    return { valid: true };
  }

  function init(opts) {
    opts = opts || {};
    _state = opts.state || null;
    _helpers = opts.helpers || {};
    console.log('[ZUG][COASTERS] init', opts.product || null);
    if (!_state) { console.warn('[ZUG][COASTERS] init called without state'); return; }
    var cs = _ensureCoasterState(_state);
    cs.enabled = true;

    var printingOpts = document.querySelectorAll('.zug-printing__opt');
    printingOpts.forEach(function(btn) {
      if (btn._zugWired) return;
      btn._zugWired = true;
      btn.addEventListener('click', function() {
        var isDouble = btn.dataset.printing === 'double';
        printingOpts.forEach(function(b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
        });
        var valEl = document.getElementById('zug-printing-value');
        if (valEl) valEl.textContent = isDouble ? 'Double sided' : 'Single sided';
        var hiddenEl = document.getElementById('zug-printing-hidden');
        if (hiddenEl) hiddenEl.value = isDouble ? 'double' : 'single';
        onToggleDoubleSided(isDouble);
        if (_helpers.updateGating) _helpers.updateGating();
      });
    });


    var frontUploadBtn = document.getElementById('zug-coaster-upload-front');
    var backUploadBtn = document.getElementById('zug-coaster-upload-back');
    var frontInput = document.getElementById('zug-coaster-input-front');
    var backInput = document.getElementById('zug-coaster-input-back');

    if (frontUploadBtn && frontInput && !frontUploadBtn._zugWired) {
      frontUploadBtn._zugWired = true;
      frontUploadBtn.addEventListener('click', function () { frontInput.click(); });
    }
    if (frontInput && !frontInput._zugWired) {
      frontInput._zugWired = true;
      frontInput.addEventListener('change', function (e) {
        if (e.target.files && e.target.files[0] && _helpers.handleCoasterFile) {
          _helpers.handleCoasterFile('front', e.target.files[0]);
        }
      });
    }
    if (backUploadBtn && backInput && !backUploadBtn._zugWired) {
      backUploadBtn._zugWired = true;
      backUploadBtn.addEventListener('click', function () { backInput.click(); });
    }
    if (backInput && !backInput._zugWired) {
      backInput._zugWired = true;
      backInput.addEventListener('change', function (e) {
        if (e.target.files && e.target.files[0] && _helpers.handleCoasterFile) {
          _helpers.handleCoasterFile('back', e.target.files[0]);
        }
      });
    }

    _syncUI();
    console.log('[ZUG][COASTER] init complete', { doubleSided: cs.doubleSided });
  }

  function getState() {
    return _state ? _state.coaster : null;
  }

  function reset() {
    if (_state && _state.coaster) {
      _state.coaster = null;
    }
    _ensureCoasterState(_state || {});
  }

  window.ZUGModalCoasters = {
    isCoasterProduct: isCoasterProduct,
    init: init,
    onToggleDoubleSided: onToggleDoubleSided,
    onUploadComplete: onUploadComplete,
    getPricing: getPricing,
    validate: validate,
    getState: getState,
    reset: reset,
    MIN_QTY: MIN_QTY,
    MAX_QTY: MAX_QTY,
    SUPPORTED_QUANTITIES: SUPPORTED_QUANTITIES.slice()
  };
})();
